import React, { useState } from 'react';
import Button from '../Button';
import { ReactComponent as PadLockGreyIcon } from '../svgs/padlockIconGrey.svg';
import { ReactComponent as DropdownIcon } from '../svgs/dropdownIcon.svg';


const SystemConfigForm = () => {
  // State for the form fields
  const [field1, setField1] = useState('');
  const [field2, setField2] = useState('');
  const [dateFormat, setDateFormat] = useState('mm-dd-yyyy');
  const [timeFormat, setTimeFormat] = useState('24 hour format (14:30)');

  const [field1Disabled, setField1Disabled] = useState(true);
  const [field2Disabled, setField2Disabled] = useState(true);

  // Function to handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // Implement your save logic here
    console.log('Saved form data:', {
      field1,
      field2,
      dateFormat,
      timeFormat,
    });
  };

  // Function to reset the form
  const handleReset = () => {
    setField1('');
    setField2('');
    setDateFormat('mm-dd-yyyy');
    setTimeFormat('24 hour format (14:30)');
    setField1Disabled(true);
    setField2Disabled(true);
  };

    // Function to toggle the disabled state of the input fields
    const toggleInputDisabled = (fieldIndex) => {
        if (fieldIndex === 1) {
          setField1Disabled((prevState) => !prevState);
        } else {
          setField2Disabled((prevState) => !prevState);
        }
      };

  return (
    <form onSubmit={handleSubmit} className='create-customer-form-expanded system-config-form'>
      <div className="">
        <label htmlFor="field1">Set currency</label>
        <div className="">
          <input
            type="text"
            id="field1"
            value={field1}
            onChange={(e) => setField1(e.target.value)}
            disabled={field1Disabled}
            placeholder='$ USD'
          />
          <span className="" onClick={() => toggleInputDisabled(1)}>
            <PadLockGreyIcon className='default-disabled'/>
            {/* {field1Disabled ? <PadLockGreyIcon className='default-disabled'/> : <PadLockIcon className='default-disabled'/>} */}
          </span>
        </div>
      </div>

      <div className="">
        <label htmlFor="field2">Set measurement scale</label>
        <div className="">
          <input
            type="text"
            id="field2"
            value={field2}
            onChange={(e) => setField2(e.target.value)}
            disabled={field2Disabled}
            placeholder='Pounds (lbs)'
          />
          <span className="" onClick={() => toggleInputDisabled(2)}>
          {/* {field2Disabled ? <PadLockGreyIcon className='default-disabled'/> : <PadLockIcon className='default-disabled'/>} */}
            <PadLockGreyIcon className='default-disabled'/>
          </span>
          
        </div>
      </div>
      <div className='flex gap-10'>
        <div className="flex flex-col">
          <label htmlFor="dateFormat">Set date format</label>
          <select
            id="dateFormat"
            value={dateFormat}
            onChange={(e) => setDateFormat(e.target.value)}
          >
            <option value="mm-dd-yyyy">mm-dd-yyyy</option>
            <option value="dd-mm-yyyy">dd-mm-yyyy</option>
            <option value="yyyy-mm-dd">yyyy-mm-dd</option>
          </select>
          <DropdownIcon className='default-disabled'/>
        </div>

        <div className="flex flex-col">
          <label htmlFor="timeFormat">Set time format</label>
          <select
            id="timeFormat"
            value={timeFormat}
            onChange={(e) => setTimeFormat(e.target.value)}
          >
            <option value="24 hour format (14:30)">24 hour format (14:30)</option>
            <option value="12 hour format (2:30pm)">12 hour format (2:30pm)</option>
          </select>
          <DropdownIcon className='default-disabled'/>
        </div>
      </div>
      <div className="flex gap-6">
        <Button type="submit" className="">
          Save
        </Button>
        <Button type="button" className="" onClick={handleReset} style={{background: 'none', color: '#707783', fontWeight: '600'}}>
          Reset changes
        </Button>
      </div>
    </form>
  );
};

export default SystemConfigForm;